import { liveQuery } from 'dexie'
import { db } from './indexeddb'
import { baseEntityIdentity } from './useStableEntityArray'
import { createSharedList } from './sharedList'
import type { Tag } from './models'

/**
 * **Die Etiketten-Liste, einmal für alle.** Jede Aufgabenzeile braucht sie,
 * um aus gespeicherten Kennungen Namen und Farben zu machen — aber sie alle
 * brauchen dieselbe. Das Warum steht bei {@link createSharedList}.
 */
const tags = createSharedList<Tag>(
  next => {
    // Ein Lesefehler darf die Liste nicht abreißen lassen — sie behält dann
    // den letzten Stand, wie jede andere Anzeige auch.
    const sub = liveQuery(() => db.tags.toArray()).subscribe({ next, error: () => {} })
    return () => sub.unsubscribe()
  },
  items => items.map(baseEntityIdentity).join(','),
)

/** Alle Etiketten, live — ein Abo für die ganze App. */
export const useSharedTags = tags.use

/** Nur für Tests: setzt den geteilten Stand zurück. */
export const resetSharedTags = tags.reset
